import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Publisher } from '../../../../../models/publisher';
import { PublisherService } from '../../../../../services/publisher.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from '../../../../../helpers';

@Component({
    selector: 'app-publisher-detail',
    templateUrl: './publisher-detail.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublisherDetailComponent implements OnInit {
    publisher: Publisher = new Publisher();
    activeTab: number = 0;
    routePath: string;
    route: ActivatedRoute;
    userGroupVisible: boolean = false;
    userVisible: boolean = false;

    constructor(
        private publisherService: PublisherService,
        private router: Router,
        route: ActivatedRoute
    ) {
        const publisherName = route.snapshot.queryParams.name;
        if (publisherName) route.snapshot.data.breadcrumb = publisherName;
        this.publisher.id = route.snapshot.params.id;

        this.activeTab = route.snapshot.queryParams.tab;
        if (!this.activeTab) this.activeTab = 0;
        if (this.activeTab == PublisherDetailTab.UserGroup)
            this.userGroupVisible = true;
        if (this.activeTab == PublisherDetailTab.User) this.userVisible = true;
    }

    ngOnInit() {
        Helpers.updateCssForSharedComponents();
        this.getPublisher();
    }

    getPublisher() {
        Helpers.setLoading(true);
        this.publisherService.find(this.publisher.id).subscribe(res => {
            Helpers.setLoading(false);
            this.publisher = res.data;
            this.routePath = 'owner/publisher-detail/' + this.publisher.id;
        });
    }

    onClickUserGroupTab() {
        this.userGroupVisible = true;
    }

    onClickUserTab() {
        this.userVisible = true;
    }
}

export enum PublisherDetailTab {
    Detail = 0,
    UserGroup = 1,
    User = 2,
    Inventory = 3
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/publisher-detail/publisher-detail.component.ts